"use client";

import { useEffect, useRef, ReactNode } from "react";

/**
 * Shows `fallback` (server-rendered HTML) until `children` (client component) mounts.
 * Once mounted, hides the fallback and shows the client app.
 */
export function SSRReplacer({
  children,
  fallback,
}: {
  children: ReactNode;
  fallback: ReactNode;
}) {
  const mounted = useRef(false);
  const fallbackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    mounted.current = true;
    // Hide server content once client is ready
    if (fallbackRef.current) {
      fallbackRef.current.style.display = "none";
    }
  }, []);

  return (
    <>
      <div ref={fallbackRef}>{fallback}</div>
      {children}
    </>
  );
}
